<main
    class="md:top-[55px] md:right-0 md:left-0 md:z-0 md:fixed grid !bg-gray-100 mt-14 md:mt-4 md:ml-[200px] p-8 h-[calc(100vh-70px)] overflow-x-hidden overflow-y-auto"
    [ngClass]="{
        'bg-white dark:bg-gray-800': bgColor() !== 'transparent',
        'bg-transparent': bgColor() === 'transparent',
        'border border-gray-300 dark:border-gray-700': hasBorder()
    }"
>
    <ng-content></ng-content>
</main>
